<svg
  xmlns="http://www.w3.org/2000/svg"

  viewBox="0 0 24 24"
  class="arrow-icon"
   height="100%"
    width="100%"
>
  <rect class="top" width="17" height="2" x="3" y="6" />
  <rect class="middle" width="17" height="2" x="3" y="11" />
  <rect class="bottom" width="17" height="2" x="3" y="16" />
</svg>
